// extracted by mini-css-extract-plugin
export default {"root":"dv7IdAmXcoVQTlgWTI3J"};